"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0902 9.05835C17.5664 9.05835 18 9.44895 18 9.99622C18 10.5213 17.5955 10.9417 17.0902 10.9417L5.0964 10.9417L9.36841 15.3812C9.72714 15.754 9.72714 16.3476 9.36841 16.7204C9.00967 17.0932 8.43843 17.0932 8.0797 16.7204L2.24239 10.6542L2.22875 10.6377C2.12977 10.5177 2.06135 10.3778 2.0263 10.2321L2.01 10.1644L2.01 10.1457C2.0078 10.1311 2.00566 10.1135 2.00427 10.0936C1.99171 9.9535 2.00625 9.80526 2.05586 9.66307C2.0976 9.53777 2.16378 9.42748 2.25722 9.33038L8.07215 3.28744C8.25641 3.08363 8.50899 3 8.72041 3C8.95417 3 9.18715 3.0988 9.36113 3.2796C9.71986 3.6524 9.71986 4.24604 9.36113 4.61883L5.08912 9.05835L17.0902 9.05835Z",
    fill: "#727B7F"
  }));
};